export const dateWithoutTime = ((date) => (date ? date.toISOString().split('T')[0] : null))

export const daysAgo = (n, from, returnUnformatted) => {
  const d = from ?? new Date()
  d.setDate(d.getDate() - n)

  if (returnUnformatted) {
    return d
  }

  return dateWithoutTime(d)
}
